import { render } from "./px-tabs-mobile.vue?vue&type=template&id=01a5d52a&ts=true"
import script from "./px-tabs-mobile.vue?vue&type=script&lang=ts"
export * from "./px-tabs-mobile.vue?vue&type=script&lang=ts"

import "./px-tabs-mobile.vue?vue&type=style&index=0&id=01a5d52a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__